/**
 * Created by zqy on 18/12/22.
 */
export default class RegExpConst {
    static PWD = /^[A-Za-z\d]{6,18}$/;
    static EMAIL = /^[a-z0-9]+([._\\-]*[a-z0-9])*@([a-z0-9]+[-a-z0-9]*[a-z0-9]+.){1,63}[a-z0-9]+$/;
    static PHONE = /^((13[0-9])|(15[0-9])|(14[0-9])|(16[0-9])|(17[0-9])|(18[0-9])||(19[0-9]))\d{8}$/;
    // static PHONE = /^((13[0-9])|(15[0-9])|(14[^4,\D])|(166)|(17[0-9])|(18[0-9])|(19[8,9])|1545678)\d{4}\d{4}$/;
    static PHONE_TEST = /^1545678\d{4}$/;
    static WECHAT = /^[a-zA-Z\d_]{5,50}$/;
    static QQ = /^[0-9]{5,15}$/;
    static AUTHCODE = /^\d{6}$/;

    static organizationCode = /^[a-zA-Z0-9-]+$/; // 组织机构
    static businessLicense = /(^[a-zA-Z0-9_-]{15}$)|(^[a-zA-Z0-9_-]{18}$)/;
    static fixedTele = /^((0\d{2,3})-)?(\d{7,8})(-(\d{3,}))?$|(0\d{10})$/;
    static faxTele = /(^(\d{3,4}-)?\d{7,8})$|^((1[0-9][0-9]\d{8}$))/; //传真电话ad
    static postCode = /^[0-9]{6}$/; //邮政编码
}